module.exports = __webpack_public_path__ + "static/media/PlankMale.f2a6d4de.svg";